import { createMockCreator } from '@csp/test-common-utils';
import { AnalyticsAPI } from '../AnalyticsContext';

const analyticsContext: AnalyticsAPI = {
  isEnabled: true,
  isInitialized: true,
  async track(_, __) {},
  async page(_, __) {},
};

export const createAnalyticsContextMock = createMockCreator<AnalyticsAPI>(analyticsContext);
